
import { Injectable } from '@angular/core';
import * as cardValidator from 'card-validator';

export interface CardInformation {
    isPotentiallyValid : boolean;
    card : Card;
}

export interface Card {
    type : 'visa' | 'master-card' | 'american-express' | 'diners-club' | 'discover' | 'jcb' | 'unionpay' | 'maestro';
    niceType : string;
}

@Injectable()
export class CreditCardService {
    getInfo(cardNumber): CardInformation {
        return cardValidator.number(cardNumber);
    }
}